exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-blue[data-v-18463c08] {\n  color: #0066B3 !important;\n}\n.link-footer-icon[data-v-18463c08] {\n  margin: 5px;\n  background-color: #0066B3;\n  text-decoration: none;\n  transition: all 0.2s ease-in-out;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.link-footer-icon[data-v-18463c08]:hover {\n  opacity: 0.8;\n}\n.footer-link[data-v-18463c08] {\n  padding: 5px;\n  line-height: 1;\n}", ""]);

// exports
